import { getConfigWithKeys, AUTH0_CONFIG } from '@cibo/core'

export type PROFILE_CONFIG = 'homepage'

export const Config = getConfigWithKeys<AUTH0_CONFIG | PROFILE_CONFIG>()
